<template>
    <div class="privacyContent">
        <Button class="settingsItem"
            v-if="auth.id"
            @click="resetPassword"
            prefixIcon="drafts"
            appearance="secondary">
            {{ siteContent.sendPasswordResetEmail }}
        </Button>
        <p>{{ siteContent.learnMoreAbout }} <router-link to="/terms">{{ siteContent.howWeHandleData }}</router-link> {{ siteContent.and }} <router-link to="/privacy">{{ siteContent.whatTermsAreApplied }}</router-link> {{ siteContent.whenUsingTheSite }}</p>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Privacy',
        methods: {
            ...mapActions('authentication',['logoutUser','sendPasswordReset']),

            async resetPassword() {
                try {
                    await this.sendPasswordReset()
                } catch {
                    this.$toasted.show('Couldn\'t send email. Something went wrong on our end :(')
                } finally {
                    this.$toasted.show('Further information was sent to your email.')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';


</style>